import Vue from "vue";
import CacheHelper from '@/helper/CacheHelper.js';
//service
import BzbsAuth from "@/core/Account/service/BzbsAuth.js";
/**
 * setting
 * @method setTitle
 * @method setMsg
 * @method setBtnOk
 * @method setBtnCancel
 * @method setTag
 * @method clearModal
 * action
 * @method show
 * @method hide
 * set event callback
 * @method onClickOk
 * @method onHidden
 * event
 * @event sendCallbackOk
 * @event sendCallbackHidden
 */
export function ConfirmModalController () {
    this.title = '';
    this.msg = '';
    this.msgAll = '';
    this.btnOk = '';
    this.btnCancel = '';
    this.tag = '',
    this.busModal = new Vue();

    this.callbackOk = null;
    this.callbackCancel = null;
    this.callbackHidden = null;

    //#region setter
    this.setData = function(data) {
        this.title = data.title;
        this.msg = data.msg;
        this.msgAll = data.msgAll;
        this.btnOk = data.btnOk;
        this.btnCancel = data.btnCancel;
        //ซ่อนปุ่มกากบาท
        this.hideClose = data.hideClose;
        //สลับสไตล์ปุ่มตกลง ยกเลิก
        this.buttonStyle = data.buttonStyle;
        //ใช้ function callback เพราะ default เป็นกดยกเลิกสมาชิก
        this.userCallback = data.userCallback;
        return this;
    };
    this.setTag = function(tag) {
        this.tag = tag;
        return this;
    };
    this.clearModal = function() {
        this.title = '';
        this.msg = '';
        this.btnOk = '';
        this.btnCancel = '';
        this.tag = '';
        this.hideClose = false;
        this.buttonStyle = false;
        this.userCallback = false;
        return this;
    };
    //#endregion setter

    //#region method
    this.show = function(params) {
        var config = {
            title: this.title,
            msg: this.msg,
            msgAll: this.msgAll,
            btnOk: this.btnOk,
            btnCancel: this.btnCancel,
            params: params,
            tag: this.tag,
            hideClose: this.hideClose,
            buttonStyle: this.buttonStyle,
            userCallback: this.userCallback,
        };
        this.busModal.$emit('show', config);
    };
    this.hide = function() {
        this.busModal.$emit('hide');
    };
    //#endregion method

    //#region event
    this.onClickOk = function(callback) {
        if (typeof callback == 'function') {
            this.callbackOk = callback;
        }
    };
    this.sendCallbackOk = function(data) {
        if (typeof this.callbackOk == 'function') {
            this.callbackOk(data);
        }
    };

    this.onClickCancel = function(callback) {
        if (typeof callback == 'function') {
            this.callbackCancel = callback;
        }
    };
    this.onError = function(callback) {
        if (typeof callback == 'function') {
            this.callbackCancel = callback;
        }
    },
    this.sendCallbackCancel = function(data) {
        if (typeof this.callbackCancel == 'function') {
            this.callbackCancel(data);
        }
    };

    this.onHidden = function(callback) {
        if (typeof callback == 'function') {
            this.callbackHidden = callback;
        }
    };
    this.sendCallbackHidden = function(data) {
        if (typeof this.callbackHidden == 'function') {
            this.callbackHidden(data);
        }
    };
    this.sendCancelRequest = function(data) {
        if(data.active === 'nescafe') {
            this.requestSingle(data.keepData)
        } else {
            this.requestAll(data.keepData)
        }
    }

    this.requestAll = function(keepData) {
        let cacheHelper = new CacheHelper();
        let token = cacheHelper.getCache("BzbsUser").token
        BzbsAuth.apiDeactive(token, keepData)
        .subscribe(
            data => {
                console.log(data)
                window.location.replace('/inactiveuser')
            },
            err => {
                let params;
                if(err.message === 'Payment 2126246110770981') {
                    params = 'Shopyangpro'
                } else if (err.message === 'Payment 1122821718114359') {
                    params = 'waterdelivery'
                } else {
                    params = 'home'
                }
                this.sendCallbackCancel(params)
                this.onError(err)
            }
        )
    };
    this.requestSingle = function(keepData) {
        let cacheHelper = new CacheHelper();
        let token = cacheHelper.getCache("BzbsUser").token
        BzbsAuth.apiDeactiveSingle(token, keepData)
        .subscribe(
            data => {
                console.log(data)
                window.location.replace('/inactiveuser')
            },
            err => {
                let params;
                if(err.message.toLowerCase().includes('shopyangpro')) {
                    params = 'Shopyangpro'
                } else {
                    params = 'waterdelivery'
                }
                this.sendCallbackCancel(params)
                this.onError(err)
            }
        )
    }
    //#endregion event
}
